'use client';
// 商品頁 - 投入獎券數

import useModalStore from '@/store/useModalStore';
import useUserStore from '@/store/useUserStore';
import AmountSelect from '@/components/button/AmountSelect';
import dayjs from '@/common/dayjs';

interface Props {
    item: any;
    amount: number;
    setAmount: (amount: number) => void;
}

const ItemAmountSelect = ({ item, amount, setAmount }: Props) => {
    const { user } = useUserStore();
    const { balance = 0, uid } = user || {};
    const { openModal } = useModalStore();
    const {
        stardustCost = 0,
        beginTime,
        endTime,
        winnerCount = 0,
        maxTicketsPerUser,
        myTicketCount = 0,
    } = item || {};

    const now = dayjs();
    const isNotStarted = beginTime && now.isBefore(dayjs(beginTime)); // 尚未開始
    const isEnd = endTime && now.isAfter(dayjs(endTime)); // 已結束
    const isOutOfStock = !winnerCount; // 抽獎類型改用 winnerCount（抽獎人數）判斷
    // maxTicketsPerUser 為 null 代表無限制，個人投入抽獎券數達上限才算達標
    const isTicketLimitReached = maxTicketsPerUser != null && myTicketCount >= maxTicketsPerUser;
    // 個人剩餘可投入的抽獎券數（無限制時不設上限）
    const remainingTickets =
        maxTicketsPerUser != null ? Math.max(maxTicketsPerUser - myTicketCount, 0) : undefined;
    const isDisabled = isNotStarted || isEnd || isOutOfStock || isTicketLimitReached;

    // 總消耗星塵數
    const totalCost = stardustCost * amount;

    // 點擊抽獎
    const onDraw = () => {
        if (!uid) return openModal('LOGIN');
        if (balance < totalCost) return openModal('STARDUST_INSUFFICIENT');
        openModal('ITEM', { ...item, drawAmount: amount, balance });
    };

    // 按鈕文字
    const buttonLabel = (() => {
        if (isNotStarted) return '即將開始';
        if (isEnd) return '已結束';
        if (isOutOfStock) return '已結束';
        if (isTicketLimitReached) return '已達投入上限';
        return '參加抽獎';
    })();

    return (
        <div className="space-y-5">
            <div className="flex items-center gap-x-4.5 gap-y-5 text-btn1 flex-wrap">
                <span className="text-black4">投入抽獎券</span>

                {/* 數量選擇 */}
                <AmountSelect
                    value={amount}
                    onChange={setAmount}
                    min={1}
                    max={isDisabled ? 0 : remainingTickets}
                />

                <span className="text-vPurple">需消耗{totalCost}星塵</span>
            </div>

            {/* 抽獎按鈕 */}
            <button
                onClick={onDraw}
                disabled={isDisabled}
                className="hidden text-btn1 w-full text-center text-[#fff] bg-vPurple round py-3.5 trans hover:bg-purple disabled:bg-black2 lg:block"
            >
                {buttonLabel}
            </button>
        </div>
    );
};

export default ItemAmountSelect;
